import { render, staticRenderFns } from "./advertisePositionTab.vue?vue&type=template&id=07a8909a&scoped=true"
import script from "./advertisePositionTab.vue?vue&type=script&lang=js"
export * from "./advertisePositionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a8909a",
  null
  
)

export default component.exports